import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import IconBack from './icon_back.svg';
import s from './index.module.scss';

export const BackButton = ({ onClick, className }) => {
  const { t } = useTranslation('components');
  return (
    <button type="button" onClick={onClick} className={classnames(s.btn_back, className)}>
      <img src={IconBack} width={28} height={28} alt={t('back_button.alt')} />
      <span className="f-16 f-500">{t('back_button.label')}</span>
    </button>
  );
};
